import { createContext, ReactElement, useContext } from "react";
import GetMembros, { ResponseMembrosCheckin } from "../services/getMembros";


export const MembrosCheckinContex = createContext<ResponseMembrosCheckin>(null);


export const ProviderMembrosCheckin = ({children}: { children: ReactElement | ReactElement[] }) => {

  const context = GetMembros();

  return (
    <>
      <MembrosCheckinContex.Provider value={context}>
        {children}
      </MembrosCheckinContex.Provider>
    </>
  )
}

export const useServicesMembrosCheckin = () => {

  const context = useContext(MembrosCheckinContex);

  return context
}
